module.exports = __webpack_public_path__ + "assets/7e97e4e5026b024871eafac609d42c8c.mp3";